import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { SorReading, Word } from '@/features/science-of-reading/api/types'

interface LessonRuntimeState {
  wordsById: Record<string, Word>;
  readingsById: Record<string, SorReading>;
}

const initialState: LessonRuntimeState = {
  wordsById: {},
  readingsById: {},
}

const lessonRuntimeSlice = createSlice({
  name: 'lessonRuntime',
  initialState,
  reducers: {
    cacheLessonWords: (state, action: PayloadAction<Word[]>) => {
      for (const word of action.payload) state.wordsById[word.id] = word
    },
    cacheLessonReadings: (state, action: PayloadAction<SorReading[]>) => {
      for (const reading of action.payload) state.readingsById[reading.id] = reading
    },
  },
})

export const { cacheLessonWords, cacheLessonReadings } = lessonRuntimeSlice.actions
export default lessonRuntimeSlice.reducer
